
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取搜索集合
    GetVideoVideoSearchList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/video/VideoSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取视频详细信息
    GetVideoVideoDetailed({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/video/VideoDetailed',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    VideoAddVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/video/VideoAddVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    
    VideoDelVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/video/VideoDelVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },

}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
